let trustedHtmlFilter = ($sce) => {
    'ngInject';
    return (input) => {
        return $sce.trustAsHtml(input);
    };
};

export default trustedHtmlFilter;